import moment from "moment-timezone";
import { INITIAL_STATE } from "./moduleAuthState";

export default {
  SET_ID_TOKEN(state, payload) {
    state.idToken = payload.idToken;
  },

  SET_USER(state, payload) {
    state.user = payload.user;
  },
  SET_LOGIN_SUCCESS(state) {
    state.lastLoginSuccess = moment().toISOString();
  },

  START_REFRESH_TOKEN(state, symbol) {
    state.refreshTokenRequestSymbols = [
      ...state.refreshTokenRequestSymbols,
      symbol,
    ];
  },

  FINISH_REFRESH_TOKEN(state, symbol) {
    state.refreshTokenRequestSymbols = state.refreshTokenRequestSymbols.filter(
      sym => sym !== symbol
    );
  },

  SET_ACCOUNT_ID(state, payload) {
    state.accountId = payload.accountId;
  },

  SET_RG_EXTERNAL_TOKEN(state, payload) {
    state.rgExternalToken = payload.token;
  },

  SET_RG_GROUP_ID(state, payload) {
    state.rgGroupId = payload.id;
  },

  RESET_STATE(state) {
    Object.assign(state, INITIAL_STATE);
  },
};
